import dayjs from 'dayjs'

import type { PredictionEvent } from './types'

const ACTIVE_MATCH_INTERVAL_MS = 5_000
const FALLBACK_INTERVAL_MS = 30_000
const IMMINENT_KICKOFF_WINDOW_S = 30

/**
 * Port of cdc-web `services/knockOuts/utils/eventListRefreshInterval.ts`
 * （`pickEventListRefreshInterval`；SWR 适配器 `...FromResponse` 不抄——RQ 的
 * refetchInterval 回调直接给 `query.state.data`，调用处自行 flatMap 分页）。
 *
 * 按列表内容决定刷新节奏：任一进行中赛事 → 5s；30s 内即将开赛的 → 对齐开赛
 * 点唤醒；否则回退 30s。已结束 / league 型事件不加速。空列表返回 0 关闭轮询。
 * cdc-market 无 `EventType.League` 枚举，`event_type === 'league'` 用字面量。
 */
export const pickEventListRefreshInterval = (
  events: PredictionEvent[] | undefined,
  fallbackMs: number = FALLBACK_INTERVAL_MS,
): number => {
  if (!events?.length) return 0

  const now = dayjs()
  let needsFastPoll = false
  let earliestKickoffMs: number | undefined

  for (const event of events) {
    if (event.status !== 'active') continue
    if (event.event_type === 'league') continue

    const kickoff = dayjs(event.event_date)
    if (kickoff.isBefore(now)) {
      needsFastPoll = true
      break
    }

    const diffSec = kickoff.diff(now, 'second')
    if (diffSec <= IMMINENT_KICKOFF_WINDOW_S) {
      const ms = diffSec * 1_000
      if (earliestKickoffMs === undefined || ms < earliestKickoffMs) {
        earliestKickoffMs = ms
      }
    }
  }

  if (needsFastPoll) return ACTIVE_MATCH_INTERVAL_MS
  if (earliestKickoffMs !== undefined) return Math.max(earliestKickoffMs, 1_000)
  return fallbackMs
}
